import { UserNodes } from 'views/Labs/UserNodes/UserNodes';
// import { UserProjects } from 'views/CapstoneProject/UserProjects/UserProjects';
// import { ProjectsPurchase } from 'views/CapstoneProject/ProjectsPurchase/ProjectsPurchase';
// import { ProjectsOrgPurchase } from 'views/CapstoneProject/ProjectsOrgPurchase/ProjectsOrgPurchase';
import { ProjectsView } from 'views/CapstoneProject/ProjectsView';


const routes = [
    {
        path: '/projects',
        view: ProjectsView,
        layout: 'app',
        permission: 'project.view',
        title: 'CapstoneProject.UserProject.title',
    },
    {
        path: '/projects/:lab_id/nodes',
        view: UserNodes,
        layout: 'app',
        permission: 'project.nodes.view',
        title: 'CapstoneProject.ProjectNodes.title.default'
    },
    // {
    //     path: '/projects/org',
    //     view: ProjectsOrgPurchase,
    //     layout: 'app',
    //     permission: 'scholar',
    //     title: 'CapstoneProject.ProjectEnroll.title'
    // },
    // {
    //     path: '/projects/purchase',
    //     view: ProjectsPurchase,
    //     layout: 'app',
    //     permission: 'scholar',
    //     title: 'CapstoneProject.ProjectPurchase.title'
    // }
];

export default routes;